export default __webpack_public_path__ + "static/22_32-1cf0227fb7c04a3a153f5d1ada8bb15e.png";